<template>
  <img
    :src="`https://flagsapi.com/${countryCode.toUpperCase()}/flat/64.png`"
    :class="twMerge('w-6 shrink-0', $attrs.class as string)"
  />
</template>

<script setup lang="ts">
import { twMerge } from 'tailwind-merge'

defineOptions({
  inheritAttrs: false,
})

defineProps<{
  countryCode: string
}>()
</script>
